// extracted by mini-css-extract-plugin
export default {"card":"Y6pOK","card--bordered":"n5oxl","card--with-hover":"YUsj3"};